
  export default {
    layout: 'error-page',
    head() {
    return {
      title: this.title + " | Goa App",
      meta: [{
          hid: 'og:title',
          property: 'og:title',
          content: this.title + " | Goa App"
        },
        {
          hid: 'twitter:title',
          property: 'twitter:title',
          content: this.title + " | Goa App"
        }
      ],

    }
  },
    data() {
      return {
        userId: null,
        loading: false,
        title: 'change password',
        form: {
          currentPassword: null,
          password: null,
          confirmPassword: null,
        },
        //Form error variables
        errors: {
          formError: null,
          formErrMsg: "Opps! Something went wrong, please try again."
        },
        // Form submit variables
        submit: {
          loading: false,
          success: false,
          errored: false
        }
      }
    },

     // Check login token
  mounted() {
    //Pass expected role for auth
    if (localStorage.getItem("authToken") != (null || undefined)) {
       if (localStorage.getItem("profile") != (null || undefined)) {
          let profile = JSON.parse(localStorage.getItem("profile"));
           this.userId = profile._id;
        }
        this.token = localStorage.getItem("authToken");

    } else {
      this.$router.push({
        path: '/accounts/login/'
      })
    }
  },
    methods: {
      // To clear the submit error message
      clearFormErrMsg() {
        this.errors.formError = null;
        this.submit.success = false
        this.submit.errored = false
      },
      // Validate and Submit form data to LOGIN
      sendMessage() {
        // Clear all submit errors before API call
        this.errors.formError = null;
        this.submit.success = false
        this.submit.errored = false
        // Validate all fields for making the API call, throw error and not call API if validation errors are present
        this.$refs.registrationForm.validate().then((success) => {
          if (!success) {
            // run your error code here
            this.errors.formError = "One or more incorrect fields present, please fix.";
          } else {
            // If Valid form
            // Create url encoded formData instance to pass the data to the API
            var formData = new URLSearchParams();
            formData.append("id", this.userId);
          formData.append("password", this.form.currentPassword.trim());
          formData.append("newPassword", this.form.confirmPassword.trim());
            // Add header for the API
            const headers = {
              'Content-Type': 'application/x-www-form-urlencoded',
              Authorization: 'bearer ' + this.token
            }
            this.submit.loading = true;
            // AXIOS api call to add SIGNIN api
            this.$axios
              .post("/api/users/changePassword", formData, {
                headers: headers
              })
              .then(response => {
                this.submit.success = true
                this.submit.errored = false
                let value = this.getCryptKey(response.data);
                localStorage.setItem("authToken", "bearer " + value.token);
                this.$router.push({
                  path: '/'
                })
              })
              .catch(error => {
                if (error.response)
                  this.errors.formErrMsg = this.getCryptKey(error.response.data)
                this.submit.success = false
                this.submit.errored = true
              })
              .finally(() => {
                this.submit.loading = false
              });
          }
        });
      },
    }
  }

